const documentDateSelector = document.getElementById("pricing-date");
const pdfViewerMain = document.getElementById("pdf-main");
const pdfViewerMobile = document.getElementById("pdf-main-mobile");
const pdfViewerFallback = document.getElementById("pdf-fallback");

document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll("iframe[data-pdf-src]").forEach(function (el) {
		el.src = el.getAttribute("data-pdf-src");
	});

	document.querySelectorAll("object[data-pdf-data]").forEach(function (el) {
		el.data = el.getAttribute("data-pdf-data");
	});

	document.querySelectorAll("embed[data-pdf-src]").forEach(function (el) {
		el.src = el.getAttribute("data-pdf-src");
	});
});

const dateSelectorHandler = event => {
	pdfViewerMain.setAttribute(
		"data",
		`/upload/documents/pricing/${event.currentTarget.value}.pdf`,
	);
	pdfViewerMobile.setAttribute(
		"src",
		`/pdfjs/web/viewer.html?file=https%3A%2F%2Fbtc-broker.com%2Fupload%2Fdocuments%2Fpricing%2F${event.currentTarget.value}.pdf`,
	);
	pdfViewerFallback.setAttribute(
		"src",
		`/upload/documents/pricing/${event.currentTarget.value}.pdf`,
	);
};

documentDateSelector.addEventListener("change", dateSelectorHandler);
